<!--
 * @Author: chenhongwei chenhw2019@gmail.com
 * @Date: 2023-04-07 16:03:47
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2023-12-21 10:08:57
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div
			v-if="(Array.isArray(cellValue) && cellValue.length > 0) || operations.length > 0"
			class="table-btns"
			:class="[
				calcConf.mode === 'vertical' ? 'flex-column' : 'flex-row-align-center',
				calcConf.align == 'left' && calcConf.mode !== 'vertical' ? 'flex-just-start' : 'flex-just-end',
			]"
		>
			<div
				v-for="(item, index) in btnArr.default"
				:key="index"
				class="btn-wrapper"
				:class="[calcConf.mode === 'vertical' ? '' : 'rowBtn', calcConf.mode === 'vertical' && index ? '' : '', calcConf.bigger ? 'bigger' : '']"
			>
				<component
					:size="calcConf.bigger ? 'small' : 'mini'"
					:is="(item.type && upperCase(`${item.type}Button`)) || defaultType"
					:item="item"
					:row="row"
					:row-index="rowIndex"
				></component>
			</div>
			<el-dropdown v-if="btnArr.more.length">
				<span class="el-dropdown-link yx-color-primary cursor-pointer" :class="calcConf.bigger ? 'fz-14' : 'fz-12'">更多</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(item, index) in btnArr.more" :key="index">
						<component
							:is="(item.type && upperCase(`${item.type}Button`)) || defaultType"
							:item="item"
							:row="row"
							:rowIndex="rowIndex"
							:size="calcConf.bigger ? 'small' : 'mini'"
						></component>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div v-else><div class="yx-color-primary">-</div></div>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';
import Operaters from '@/components/baseUI/operater';

export default {
	name: 'RdBtnGroup',
	components: {
		...Operaters,
	},
	mixins: [mixin],
	props: {
		showMax: {
			type: Number,
			default: 3,
		},
		bigger: {
			type: Boolean,
			default: false,
		},
		operations: {
			type: Array,
			default: () => [],
		},
		mode: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			defaultType: 'TextButton',
			defaultColumn: {
				bigger: false,
			},
		};
	},
	computed: {
		btnArr() {
			const { cellValue = [], useByTable, operations } = this;
			const { showMax = 2 } = this.calcConf;
			let btnList = cellValue;
			// 非table
			if (!useByTable) {
				btnList = operations;
			}
			let btn1 = [];
			let more = [];
			btn1 = btnList.slice(0, showMax);
			more = btnList.slice(showMax);
			return {
				default: btn1,
				more,
			};
		},
	},
	methods: {
		click(item) {
			if (item.click) {
				item.click(this.row, this.rowIndex);
			}
		},
		upperCase(str) {
			const [first] = str;
			if (first == first.toUpperCase()) return;
			return str.replace(/^\S/, s => s.toUpperCase());
		},
	},
};
</script>
<style lang="less" scoped>
.el-dropdown-menu--small {
	padding: 14px 0;
	.el-dropdown-menu__item {
		line-height: 24px;
		padding: 0 16px;
	}
}
.rowBtn {
	display: flex;
	align-items: center;
	height: 16px;
	& + & {
		&::before {
			display: inline-block;
			content: '';
			width: 1px;
			height: 8px;
			margin: auto 8px;
			background-color: #eaebf0;
		}
	}
}
.margin-0 {
	margin: 0;
}
.table-btns {
	&.flex-column {
		align-items: end;
		.el-dropdown::before {
			display: none !important;
		}
	}
	.btn-wrapper {
		height: 20px;
		line-height: 20px;
		&.bigger {
			// height: 24px;
			// line-height: 24px;
		}

		/deep/ .el-button--text {
			padding: 0;
			line-height: 18px;
			&.el-button--small {
				line-height: 22px;
			}
		}
	}
	.el-button--text {
		padding: 0;
		line-height: 18px;
		&.el-button--small {
			line-height: 22px;
		}
	}
	.el-dropdown {
		height: 20px;
		line-height: 20px;
		&::before {
			display: inline-block;
			content: '';
			width: 1px;
			height: 8px;
			margin: auto 8px;
			background-color: #eaebf0;
		}
	}
}
</style>
